// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
import { isEcosystemWallet } from "../ecosystem/is-ecosystem-wallet.js";
/**
 * Retrieves the wallet based on the provided ID.
 * @param id - The ID of the wallet.
 * @returns A promise that resolves to the wallet.
 * @internal
 */
export async function getWalletInfo(id, image) {
    if (isEcosystemWallet(id)) {
        const { getEcosystemWalletInfo } = await import("../ecosystem/get-ecosystem-wallet-info.js");
        return (image
            ? getEcosystemWalletInfo(id).then((info) => info.image_id)
            : getEcosystemWalletInfo(id));
    }
    switch (id) {
        case "smart": {
            return (image
                ? import("../custom/smart/image.js").then((img) => img.default)
                : import("../custom/smart/index.js").then((w) => w.wallet));
        }
        case "inApp": {
            return (image
                ? import("../custom/inApp/image.js").then((img) => img.default)
                : import("../custom/inApp/index.js").then((w) => w.wallet));
        }
        case "walletConnect": {
            return (image
                ? import("../custom/walletConnect/image.js").then((img) => img.default)
                : import("../custom/walletConnect/index.js").then((w) => w.wallet));
        }
        case "embedded": {
            return (image
                ? import("../custom/embedded/image.js").then((img) => img.default)
                : import("../custom/embedded/index.js").then((w) => w.wallet));
        }
        case "adapter": {
            return (image
                ? import("../custom/adapter/image.js").then((img) => img.default)
                : import("../custom/adapter/index.js").then((w) => w.wallet));
        }
        case "io.metamask": {
            return (image
                ? import("./wallet/io.metamask/image.js").then((img) => img.default)
                : import("./wallet/io.metamask/index.js").then((w) => w.wallet));
        }
        case "com.trustwallet.app": {
            return (image
                ? import("./wallet/com.trustwallet.app/image.js").then((img) => img.default)
                : import("./wallet/com.trustwallet.app/index.js").then((w) => w.wallet));
        }
        case "com.okex.wallet": {
            return (image
                ? import("./wallet/com.okex.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.okex.wallet/index.js").then((w) => w.wallet));
        }
        case "com.bitget.web3": {
            return (image
                ? import("./wallet/com.bitget.web3/image.js").then((img) => img.default)
                : import("./wallet/com.bitget.web3/index.js").then((w) => w.wallet));
        }
        case "com.binance": {
            return (image
                ? import("./wallet/com.binance/image.js").then((img) => img.default)
                : import("./wallet/com.binance/index.js").then((w) => w.wallet));
        }
        case "org.uniswap": {
            return (image
                ? import("./wallet/org.uniswap/image.js").then((img) => img.default)
                : import("./wallet/org.uniswap/index.js").then((w) => w.wallet));
        }
        case "com.safepal": {
            return (image
                ? import("./wallet/com.safepal/image.js").then((img) => img.default)
                : import("./wallet/com.safepal/index.js").then((w) => w.wallet));
        }
        case "me.rainbow": {
            return (image
                ? import("./wallet/me.rainbow/image.js").then((img) => img.default)
                : import("./wallet/me.rainbow/index.js").then((w) => w.wallet));
        }
        case "com.bybit": {
            return (image
                ? import("./wallet/com.bybit/image.js").then((img) => img.default)
                : import("./wallet/com.bybit/index.js").then((w) => w.wallet));
        }
        case "pro.tokenpocket": {
            return (image
                ? import("./wallet/pro.tokenpocket/image.js").then((img) => img.default)
                : import("./wallet/pro.tokenpocket/index.js").then((w) => w.wallet));
        }
        case "com.ledger": {
            return (image
                ? import("./wallet/com.ledger/image.js").then((img) => img.default)
                : import("./wallet/com.ledger/index.js").then((w) => w.wallet));
        }
        case "xyz.timelesswallet": {
            return (image
                ? import("./wallet/xyz.timelesswallet/image.js").then((img) => img.default)
                : import("./wallet/xyz.timelesswallet/index.js").then((w) => w.wallet));
        }
        case "global.safe": {
            return (image
                ? import("./wallet/global.safe/image.js").then((img) => img.default)
                : import("./wallet/global.safe/index.js").then((w) => w.wallet));
        }
        case "io.zerion.wallet": {
            return (image
                ? import("./wallet/io.zerion.wallet/image.js").then((img) => img.default)
                : import("./wallet/io.zerion.wallet/index.js").then((w) => w.wallet));
        }
        case "com.robinhood.wallet": {
            return (image
                ? import("./wallet/com.robinhood.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.robinhood.wallet/index.js").then((w) => w.wallet));
        }
        case "io.1inch.wallet": {
            return (image
                ? import("./wallet/io.1inch.wallet/image.js").then((img) => img.default)
                : import("./wallet/io.1inch.wallet/index.js").then((w) => w.wallet));
        }
        case "com.crypto.wallet": {
            return (image
                ? import("./wallet/com.crypto.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.crypto.wallet/index.js").then((w) => w.wallet));
        }
        case "com.exodus": {
            return (image
                ? import("./wallet/com.exodus/image.js").then((img) => img.default)
                : import("./wallet/com.exodus/index.js").then((w) => w.wallet));
        }
        case "xyz.argent": {
            return (image
                ? import("./wallet/xyz.argent/image.js").then((img) => img.default)
                : import("./wallet/xyz.argent/index.js").then((w) => w.wallet));
        }
        case "im.token": {
            return (image
                ? import("./wallet/im.token/image.js").then((img) => img.default)
                : import("./wallet/im.token/index.js").then((w) => w.wallet));
        }
        case "com.blockchain": {
            return (image
                ? import("./wallet/com.blockchain/image.js").then((img) => img.default)
                : import("./wallet/com.blockchain/index.js").then((w) => w.wallet));
        }
        case "io.magiceden.wallet": {
            return (image
                ? import("./wallet/io.magiceden.wallet/image.js").then((img) => img.default)
                : import("./wallet/io.magiceden.wallet/index.js").then((w) => w.wallet));
        }
        case "com.kraken": {
            return (image
                ? import("./wallet/com.kraken/image.js").then((img) => img.default)
                : import("./wallet/com.kraken/index.js").then((w) => w.wallet));
        }
        case "app.backpack": {
            return (image
                ? import("./wallet/app.backpack/image.js").then((img) => img.default)
                : import("./wallet/app.backpack/index.js").then((w) => w.wallet));
        }
        case "com.zengo": {
            return (image
                ? import("./wallet/com.zengo/image.js").then((img) => img.default)
                : import("./wallet/com.zengo/index.js").then((w) => w.wallet));
        }
        case "com.mewwallet": {
            return (image
                ? import("./wallet/com.mewwallet/image.js").then((img) => img.default)
                : import("./wallet/com.mewwallet/index.js").then((w) => w.wallet));
        }
        case "com.fireblocks": {
            return (image
                ? import("./wallet/com.fireblocks/image.js").then((img) => img.default)
                : import("./wallet/com.fireblocks/index.js").then((w) => w.wallet));
        }
        case "org.mathwallet": {
            return (image
                ? import("./wallet/org.mathwallet/image.js").then((img) => img.default)
                : import("./wallet/org.mathwallet/index.js").then((w) => w.wallet));
        }
        case "com.alphawallet": {
            return (image
                ? import("./wallet/com.alphawallet/image.js").then((img) => img.default)
                : import("./wallet/com.alphawallet/index.js").then((w) => w.wallet));
        }
        case "com.unstoppabledomains": {
            return (image
                ? import("./wallet/com.unstoppabledomains/image.js").then((img) => img.default)
                : import("./wallet/com.unstoppabledomains/index.js").then((w) => w.wallet));
        }
        case "app.keyring": {
            return (image
                ? import("./wallet/app.keyring/image.js").then((img) => img.default)
                : import("./wallet/app.keyring/index.js").then((w) => w.wallet));
        }
        case "xyz.frontier.wallet": {
            return (image
                ? import("./wallet/xyz.frontier.wallet/image.js").then((img) => img.default)
                : import("./wallet/xyz.frontier.wallet/index.js").then((w) => w.wallet));
        }
        case "app.omni": {
            return (image
                ? import("./wallet/app.omni/image.js").then((img) => img.default)
                : import("./wallet/app.omni/index.js").then((w) => w.wallet));
        }
        case "co.lobstr": {
            return (image
                ? import("./wallet/co.lobstr/image.js").then((img) => img.default)
                : import("./wallet/co.lobstr/index.js").then((w) => w.wallet));
        }
        case "technology.obvious": {
            return (image
                ? import("./wallet/technology.obvious/image.js").then((img) => img.default)
                : import("./wallet/technology.obvious/index.js").then((w) => w.wallet));
        }
        case "com.ambire": {
            return (image
                ? import("./wallet/com.ambire/image.js").then((img) => img.default)
                : import("./wallet/com.ambire/index.js").then((w) => w.wallet));
        }
        case "com.mtpelerin": {
            return (image
                ? import("./wallet/com.mtpelerin/image.js").then((img) => img.default)
                : import("./wallet/com.mtpelerin/index.js").then((w) => w.wallet));
        }
        case "io.internetmoney": {
            return (image
                ? import("./wallet/io.internetmoney/image.js").then((img) => img.default)
                : import("./wallet/io.internetmoney/index.js").then((w) => w.wallet));
        }
        case "app.walletnow": {
            return (image
                ? import("./wallet/app.walletnow/image.js").then((img) => img.default)
                : import("./wallet/app.walletnow/index.js").then((w) => w.wallet));
        }
        case "com.bitcoin": {
            return (image
                ? import("./wallet/com.bitcoin/image.js").then((img) => img.default)
                : import("./wallet/com.bitcoin/index.js").then((w) => w.wallet));
        }
        case "io.alpha-u.wallet.web": {
            return (image
                ? import("./wallet/io.alpha-u.wallet.web/image.js").then((img) => img.default)
                : import("./wallet/io.alpha-u.wallet.web/index.js").then((w) => w.wallet));
        }
        case "com.coin98": {
            return (image
                ? import("./wallet/com.coin98/image.js").then((img) => img.default)
                : import("./wallet/com.coin98/index.js").then((w) => w.wallet));
        }
        case "io.myabcwallet": {
            return (image
                ? import("./wallet/io.myabcwallet/image.js").then((img) => img.default)
                : import("./wallet/io.myabcwallet/index.js").then((w) => w.wallet));
        }
        case "co.arculus": {
            return (image
                ? import("./wallet/co.arculus/image.js").then((img) => img.default)
                : import("./wallet/co.arculus/index.js").then((w) => w.wallet));
        }
        case "com.opera": {
            return (image
                ? import("./wallet/com.opera/image.js").then((img) => img.default)
                : import("./wallet/com.opera/index.js").then((w) => w.wallet));
        }
        case "com.chain": {
            return (image
                ? import("./wallet/com.chain/image.js").then((img) => img.default)
                : import("./wallet/com.chain/index.js").then((w) => w.wallet));
        }
        case "io.huddln": {
            return (image
                ? import("./wallet/io.huddln/image.js").then((img) => img.default)
                : import("./wallet/io.huddln/index.js").then((w) => w.wallet));
        }
        case "com.get-verso": {
            return (image
                ? import("./wallet/com.get-verso/image.js").then((img) => img.default)
                : import("./wallet/com.get-verso/index.js").then((w) => w.wallet));
        }
        case "me.haha": {
            return (image
                ? import("./wallet/me.haha/image.js").then((img) => img.default)
                : import("./wallet/me.haha/index.js").then((w) => w.wallet));
        }
        case "pk.modular": {
            return (image
                ? import("./wallet/pk.modular/image.js").then((img) => img.default)
                : import("./wallet/pk.modular/index.js").then((w) => w.wallet));
        }
        case "org.kelp": {
            return (image
                ? import("./wallet/org.kelp/image.js").then((img) => img.default)
                : import("./wallet/org.kelp/index.js").then((w) => w.wallet));
        }
        case "io.clingon": {
            return (image
                ? import("./wallet/io.clingon/image.js").then((img) => img.default)
                : import("./wallet/io.clingon/index.js").then((w) => w.wallet));
        }
        case "com.broearn": {
            return (image
                ? import("./wallet/com.broearn/image.js").then((img) => img.default)
                : import("./wallet/com.broearn/index.js").then((w) => w.wallet));
        }
        case "com.coinomi": {
            return (image
                ? import("./wallet/com.coinomi/image.js").then((img) => img.default)
                : import("./wallet/com.coinomi/index.js").then((w) => w.wallet));
        }
        case "com.ripio": {
            return (image
                ? import("./wallet/com.ripio/image.js").then((img) => img.default)
                : import("./wallet/com.ripio/index.js").then((w) => w.wallet));
        }
        case "com.sabay.wallet": {
            return (image
                ? import("./wallet/com.sabay.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.sabay.wallet/index.js").then((w) => w.wallet));
        }
        case "io.tokoin": {
            return (image
                ? import("./wallet/io.tokoin/image.js").then((img) => img.default)
                : import("./wallet/io.tokoin/index.js").then((w) => w.wallet));
        }
        case "world.fncy": {
            return (image
                ? import("./wallet/world.fncy/image.js").then((img) => img.default)
                : import("./wallet/world.fncy/index.js").then((w) => w.wallet));
        }
        case "io.copiosa": {
            return (image
                ? import("./wallet/io.copiosa/image.js").then((img) => img.default)
                : import("./wallet/io.copiosa/index.js").then((w) => w.wallet));
        }
        case "com.liberawallet": {
            return (image
                ? import("./wallet/com.liberawallet/image.js").then((img) => img.default)
                : import("./wallet/com.liberawallet/index.js").then((w) => w.wallet));
        }
        case "io.certhis": {
            return (image
                ? import("./wallet/io.certhis/image.js").then((img) => img.default)
                : import("./wallet/io.certhis/index.js").then((w) => w.wallet));
        }
        case "com.burritowallet": {
            return (image
                ? import("./wallet/com.burritowallet/image.js").then((img) => img.default)
                : import("./wallet/com.burritowallet/index.js").then((w) => w.wallet));
        }
        case "io.ancrypto": {
            return (image
                ? import("./wallet/io.ancrypto/image.js").then((img) => img.default)
                : import("./wallet/io.ancrypto/index.js").then((w) => w.wallet));
        }
        case "network.cvl": {
            return (image
                ? import("./wallet/network.cvl/image.js").then((img) => img.default)
                : import("./wallet/network.cvl/index.js").then((w) => w.wallet));
        }
        case "io.cypherwallet": {
            return (image
                ? import("./wallet/io.cypherwallet/image.js").then((img) => img.default)
                : import("./wallet/io.cypherwallet/index.js").then((w) => w.wallet));
        }
        case "app.status": {
            return (image
                ? import("./wallet/app.status/image.js").then((img) => img.default)
                : import("./wallet/app.status/index.js").then((w) => w.wallet));
        }
        case "io.enjin": {
            return (image
                ? import("./wallet/io.enjin/image.js").then((img) => img.default)
                : import("./wallet/io.enjin/index.js").then((w) => w.wallet));
        }
        case "io.trinity-tech": {
            return (image
                ? import("./wallet/io.trinity-tech/image.js").then((img) => img.default)
                : import("./wallet/io.trinity-tech/index.js").then((w) => w.wallet));
        }
        case "app.everspace": {
            return (image
                ? import("./wallet/app.everspace/image.js").then((img) => img.default)
                : import("./wallet/app.everspace/index.js").then((w) => w.wallet));
        }
        case "io.kriptomat": {
            return (image
                ? import("./wallet/io.kriptomat/image.js").then((img) => img.default)
                : import("./wallet/io.kriptomat/index.js").then((w) => w.wallet));
        }
        case "io.oxalus": {
            return (image
                ? import("./wallet/io.oxalus/image.js").then((img) => img.default)
                : import("./wallet/io.oxalus/index.js").then((w) => w.wallet));
        }
        case "org.thetatoken": {
            return (image
                ? import("./wallet/org.thetatoken/image.js").then((img) => img.default)
                : import("./wallet/org.thetatoken/index.js").then((w) => w.wallet));
        }
        case "io.leapwallet": {
            return (image
                ? import("./wallet/io.leapwallet/image.js").then((img) => img.default)
                : import("./wallet/io.leapwallet/index.js").then((w) => w.wallet));
        }
        case "finance.islamicoin": {
            return (image
                ? import("./wallet/finance.islamicoin/image.js").then((img) => img.default)
                : import("./wallet/finance.islamicoin/index.js").then((w) => w.wallet));
        }
        case "xyz.coca": {
            return (image
                ? import("./wallet/xyz.coca/image.js").then((img) => img.default)
                : import("./wallet/xyz.coca/index.js").then((w) => w.wallet));
        }
        case "com.monarchwallet": {
            return (image
                ? import("./wallet/com.monarchwallet/image.js").then((img) => img.default)
                : import("./wallet/com.monarchwallet/index.js").then((w) => w.wallet));
        }
        case "co.filwallet": {
            return (image
                ? import("./wallet/co.filwallet/image.js").then((img) => img.default)
                : import("./wallet/co.filwallet/index.js").then((w) => w.wallet));
        }
        case "com.valoraapp": {
            return (image
                ? import("./wallet/com.valoraapp/image.js").then((img) => img.default)
                : import("./wallet/com.valoraapp/index.js").then((w) => w.wallet));
        }
        case "com.coincircle": {
            return (image
                ? import("./wallet/com.coincircle/image.js").then((img) => img.default)
                : import("./wallet/com.coincircle/index.js").then((w) => w.wallet));
        }
        case "money.snowball": {
            return (image
                ? import("./wallet/money.snowball/image.js").then((img) => img.default)
                : import("./wallet/money.snowball/index.js").then((w) => w.wallet));
        }
        case "io.paraswap": {
            return (image
                ? import("./wallet/io.paraswap/image.js").then((img) => img.default)
                : import("./wallet/io.paraswap/index.js").then((w) => w.wallet));
        }
        case "network.mrhb": {
            return (image
                ? import("./wallet/network.mrhb/image.js").then((img) => img.default)
                : import("./wallet/network.mrhb/index.js").then((w) => w.wallet));
        }
        case "com.apollox": {
            return (image
                ? import("./wallet/com.apollox/image.js").then((img) => img.default)
                : import("./wallet/com.apollox/index.js").then((w) => w.wallet));
        }
        case "com.ennowallet": {
            return (image
                ? import("./wallet/com.ennowallet/image.js").then((img) => img.default)
                : import("./wallet/com.ennowallet/index.js").then((w) => w.wallet));
        }
        case "io.loopring.wallet": {
            return (image
                ? import("./wallet/io.loopring.wallet/image.js").then((img) => img.default)
                : import("./wallet/io.loopring.wallet/index.js").then((w) => w.wallet));
        }
        case "com.bee": {
            return (image
                ? import("./wallet/com.bee/image.js").then((img) => img.default)
                : import("./wallet/com.bee/index.js").then((w) => w.wallet));
        }
        case "cc.localtrade.lab": {
            return (image
                ? import("./wallet/cc.localtrade.lab/image.js").then((img) => img.default)
                : import("./wallet/cc.localtrade.lab/index.js").then((w) => w.wallet));
        }
        case "com.xcapit": {
            return (image
                ? import("./wallet/com.xcapit/image.js").then((img) => img.default)
                : import("./wallet/com.xcapit/index.js").then((w) => w.wallet));
        }
        case "io.safematrix": {
            return (image
                ? import("./wallet/io.safematrix/image.js").then((img) => img.default)
                : import("./wallet/io.safematrix/index.js").then((w) => w.wallet));
        }
        case "com.neonwallet": {
            return (image
                ? import("./wallet/com.neonwallet/image.js").then((img) => img.default)
                : import("./wallet/com.neonwallet/index.js").then((w) => w.wallet));
        }
        case "xyz.sequence": {
            return (image
                ? import("./wallet/xyz.sequence/image.js").then((img) => img.default)
                : import("./wallet/xyz.sequence/index.js").then((w) => w.wallet));
        }
        case "app.linen": {
            return (image
                ? import("./wallet/app.linen/image.js").then((img) => img.default)
                : import("./wallet/app.linen/index.js").then((w) => w.wallet));
        }
        case "io.nabox": {
            return (image
                ? import("./wallet/io.nabox/image.js").then((img) => img.default)
                : import("./wallet/io.nabox/index.js").then((w) => w.wallet));
        }
        case "net.spatium": {
            return (image
                ? import("./wallet/net.spatium/image.js").then((img) => img.default)
                : import("./wallet/net.spatium/index.js").then((w) => w.wallet));
        }
        case "com.cryptnox": {
            return (image
                ? import("./wallet/com.cryptnox/image.js").then((img) => img.default)
                : import("./wallet/com.cryptnox/index.js").then((w) => w.wallet));
        }
        case "com.rktechworks": {
            return (image
                ? import("./wallet/com.rktechworks/image.js").then((img) => img.default)
                : import("./wallet/com.rktechworks/index.js").then((w) => w.wallet));
        }
        case "pro.assure": {
            return (image
                ? import("./wallet/pro.assure/image.js").then((img) => img.default)
                : import("./wallet/pro.assure/index.js").then((w) => w.wallet));
        }
        case "trade.flooz.wallet": {
            return (image
                ? import("./wallet/trade.flooz.wallet/image.js").then((img) => img.default)
                : import("./wallet/trade.flooz.wallet/index.js").then((w) => w.wallet));
        }
        case "app.keplr": {
            return (image
                ? import("./wallet/app.keplr/image.js").then((img) => img.default)
                : import("./wallet/app.keplr/index.js").then((w) => w.wallet));
        }
        case "com.crossmint": {
            return (image
                ? import("./wallet/com.crossmint/image.js").then((img) => img.default)
                : import("./wallet/com.crossmint/index.js").then((w) => w.wallet));
        }
        case "com.pierwallet": {
            return (image
                ? import("./wallet/com.pierwallet/image.js").then((img) => img.default)
                : import("./wallet/com.pierwallet/index.js").then((w) => w.wallet));
        }
        case "app.core": {
            return (image
                ? import("./wallet/app.core/image.js").then((img) => img.default)
                : import("./wallet/app.core/index.js").then((w) => w.wallet));
        }
        case "app.keeper-wallet": {
            return (image
                ? import("./wallet/app.keeper-wallet/image.js").then((img) => img.default)
                : import("./wallet/app.keeper-wallet/index.js").then((w) => w.wallet));
        }
        case "com.dcentwallet": {
            return (image
                ? import("./wallet/com.dcentwallet/image.js").then((img) => img.default)
                : import("./wallet/com.dcentwallet/index.js").then((w) => w.wallet));
        }
        case "com.withpaper": {
            return (image
                ? import("./wallet/com.withpaper/image.js").then((img) => img.default)
                : import("./wallet/com.withpaper/index.js").then((w) => w.wallet));
        }
        case "finance.klever": {
            return (image
                ? import("./wallet/finance.klever/image.js").then((img) => img.default)
                : import("./wallet/finance.klever/index.js").then((w) => w.wallet));
        }
        case "app.edge": {
            return (image
                ? import("./wallet/app.edge/image.js").then((img) => img.default)
                : import("./wallet/app.edge/index.js").then((w) => w.wallet));
        }
        case "com.neftipedia": {
            return (image
                ? import("./wallet/com.neftipedia/image.js").then((img) => img.default)
                : import("./wallet/com.neftipedia/index.js").then((w) => w.wallet));
        }
        case "io.goldbit": {
            return (image
                ? import("./wallet/io.goldbit/image.js").then((img) => img.default)
                : import("./wallet/io.goldbit/index.js").then((w) => w.wallet));
        }
        case "com.coingrig": {
            return (image
                ? import("./wallet/com.coingrig/image.js").then((img) => img.default)
                : import("./wallet/com.coingrig/index.js").then((w) => w.wallet));
        }
        case "io.xfun": {
            return (image
                ? import("./wallet/io.xfun/image.js").then((img) => img.default)
                : import("./wallet/io.xfun/index.js").then((w) => w.wallet));
        }
        case "io.ricewallet": {
            return (image
                ? import("./wallet/io.ricewallet/image.js").then((img) => img.default)
                : import("./wallet/io.ricewallet/index.js").then((w) => w.wallet));
        }
        case "com.antiersolutions": {
            return (image
                ? import("./wallet/com.antiersolutions/image.js").then((img) => img.default)
                : import("./wallet/com.antiersolutions/index.js").then((w) => w.wallet));
        }
        case "io.okse": {
            return (image
                ? import("./wallet/io.okse/image.js").then((img) => img.default)
                : import("./wallet/io.okse/index.js").then((w) => w.wallet));
        }
        case "com.aktionariat": {
            return (image
                ? import("./wallet/com.aktionariat/image.js").then((img) => img.default)
                : import("./wallet/com.aktionariat/index.js").then((w) => w.wallet));
        }
        case "com.itoken": {
            return (image
                ? import("./wallet/com.itoken/image.js").then((img) => img.default)
                : import("./wallet/com.itoken/index.js").then((w) => w.wallet));
        }
        case "io.zelus": {
            return (image
                ? import("./wallet/io.zelus/image.js").then((img) => img.default)
                : import("./wallet/io.zelus/index.js").then((w) => w.wallet));
        }
        case "com.cardstack": {
            return (image
                ? import("./wallet/com.cardstack/image.js").then((img) => img.default)
                : import("./wallet/com.cardstack/index.js").then((w) => w.wallet));
        }
        case "com.paybolt": {
            return (image
                ? import("./wallet/com.paybolt/image.js").then((img) => img.default)
                : import("./wallet/com.paybolt/index.js").then((w) => w.wallet));
        }
        case "org.arianee": {
            return (image
                ? import("./wallet/org.arianee/image.js").then((img) => img.default)
                : import("./wallet/org.arianee/index.js").then((w) => w.wallet));
        }
        case "io.slavi": {
            return (image
                ? import("./wallet/io.slavi/image.js").then((img) => img.default)
                : import("./wallet/io.slavi/index.js").then((w) => w.wallet));
        }
        case "com.plasma-wallet": {
            return (image
                ? import("./wallet/com.plasma-wallet/image.js").then((img) => img.default)
                : import("./wallet/com.plasma-wallet/index.js").then((w) => w.wallet));
        }
        case "tech.defiantapp": {
            return (image
                ? import("./wallet/tech.defiantapp/image.js").then((img) => img.default)
                : import("./wallet/tech.defiantapp/index.js").then((w) => w.wallet));
        }
        case "cc.avacus": {
            return (image
                ? import("./wallet/cc.avacus/image.js").then((img) => img.default)
                : import("./wallet/cc.avacus/index.js").then((w) => w.wallet));
        }
        case "org.bytebank": {
            return (image
                ? import("./wallet/org.bytebank/image.js").then((img) => img.default)
                : import("./wallet/org.bytebank/index.js").then((w) => w.wallet));
        }
        case "com.coolbitx.cwsapp": {
            return (image
                ? import("./wallet/com.coolbitx.cwsapp/image.js").then((img) => img.default)
                : import("./wallet/com.coolbitx.cwsapp/index.js").then((w) => w.wallet));
        }
        case "com.optowallet": {
            return (image
                ? import("./wallet/com.optowallet/image.js").then((img) => img.default)
                : import("./wallet/com.optowallet/index.js").then((w) => w.wallet));
        }
        case "network.trustkeys": {
            return (image
                ? import("./wallet/network.trustkeys/image.js").then((img) => img.default)
                : import("./wallet/network.trustkeys/index.js").then((w) => w.wallet));
        }
        case "app.beewallet": {
            return (image
                ? import("./wallet/app.beewallet/image.js").then((img) => img.default)
                : import("./wallet/app.beewallet/index.js").then((w) => w.wallet));
        }
        case "io.ttmwallet": {
            return (image
                ? import("./wallet/io.ttmwallet/image.js").then((img) => img.default)
                : import("./wallet/io.ttmwallet/index.js").then((w) => w.wallet));
        }
        case "io.pltwallet": {
            return (image
                ? import("./wallet/io.pltwallet/image.js").then((img) => img.default)
                : import("./wallet/io.pltwallet/index.js").then((w) => w.wallet));
        }
        case "io.helixid": {
            return (image
                ? import("./wallet/io.helixid/image.js").then((img) => img.default)
                : import("./wallet/io.helixid/index.js").then((w) => w.wallet));
        }
        case "it.airgap": {
            return (image
                ? import("./wallet/it.airgap/image.js").then((img) => img.default)
                : import("./wallet/it.airgap/index.js").then((w) => w.wallet));
        }
        case "app.qubic.wallet": {
            return (image
                ? import("./wallet/app.qubic.wallet/image.js").then((img) => img.default)
                : import("./wallet/app.qubic.wallet/index.js").then((w) => w.wallet));
        }
        case "com.holdstation": {
            return (image
                ? import("./wallet/com.holdstation/image.js").then((img) => img.default)
                : import("./wallet/com.holdstation/index.js").then((w) => w.wallet));
        }
        case "com.saakuru.app": {
            return (image
                ? import("./wallet/com.saakuru.app/image.js").then((img) => img.default)
                : import("./wallet/com.saakuru.app/index.js").then((w) => w.wallet));
        }
        case "com.3swallet": {
            return (image
                ? import("./wallet/com.3swallet/image.js").then((img) => img.default)
                : import("./wallet/com.3swallet/index.js").then((w) => w.wallet));
        }
        case "com.payperless": {
            return (image
                ? import("./wallet/com.payperless/image.js").then((img) => img.default)
                : import("./wallet/com.payperless/index.js").then((w) => w.wallet));
        }
        case "digital.minerva": {
            return (image
                ? import("./wallet/digital.minerva/image.js").then((img) => img.default)
                : import("./wallet/digital.minerva/index.js").then((w) => w.wallet));
        }
        case "finance.voltage": {
            return (image
                ? import("./wallet/finance.voltage/image.js").then((img) => img.default)
                : import("./wallet/finance.voltage/index.js").then((w) => w.wallet));
        }
        case "com.lif3": {
            return (image
                ? import("./wallet/com.lif3/image.js").then((img) => img.default)
                : import("./wallet/com.lif3/index.js").then((w) => w.wallet));
        }
        case "net.shinobi-wallet": {
            return (image
                ? import("./wallet/net.shinobi-wallet/image.js").then((img) => img.default)
                : import("./wallet/net.shinobi-wallet/index.js").then((w) => w.wallet));
        }
        case "com.kryptogo": {
            return (image
                ? import("./wallet/com.kryptogo/image.js").then((img) => img.default)
                : import("./wallet/com.kryptogo/index.js").then((w) => w.wallet));
        }
        case "com.feralfile.app": {
            return (image
                ? import("./wallet/com.feralfile.app/image.js").then((img) => img.default)
                : import("./wallet/com.feralfile.app/index.js").then((w) => w.wallet));
        }
        case "com.bifrostwallet": {
            return (image
                ? import("./wallet/com.bifrostwallet/image.js").then((img) => img.default)
                : import("./wallet/com.bifrostwallet/index.js").then((w) => w.wallet));
        }
        case "com.nufinetes": {
            return (image
                ? import("./wallet/com.nufinetes/image.js").then((img) => img.default)
                : import("./wallet/com.nufinetes/index.js").then((w) => w.wallet));
        }
        case "io.wallet3": {
            return (image
                ? import("./wallet/io.wallet3/image.js").then((img) => img.default)
                : import("./wallet/io.wallet3/index.js").then((w) => w.wallet));
        }
        case "com.abra": {
            return (image
                ? import("./wallet/com.abra/image.js").then((img) => img.default)
                : import("./wallet/com.abra/index.js").then((w) => w.wallet));
        }
        case "app.imem": {
            return (image
                ? import("./wallet/app.imem/image.js").then((img) => img.default)
                : import("./wallet/app.imem/index.js").then((w) => w.wallet));
        }
        case "com.premanft": {
            return (image
                ? import("./wallet/com.premanft/image.js").then((img) => img.default)
                : import("./wallet/com.premanft/index.js").then((w) => w.wallet));
        }
        case "so.onekey.app.wallet": {
            return (image
                ? import("./wallet/so.onekey.app.wallet/image.js").then((img) => img.default)
                : import("./wallet/so.onekey.app.wallet/index.js").then((w) => w.wallet));
        }
        case "finance.slingshot": {
            return (image
                ? import("./wallet/finance.slingshot/image.js").then((img) => img.default)
                : import("./wallet/finance.slingshot/index.js").then((w) => w.wallet));
        }
        case "com.kriptonio": {
            return (image
                ? import("./wallet/com.kriptonio/image.js").then((img) => img.default)
                : import("./wallet/com.kriptonio/index.js").then((w) => w.wallet));
        }
        case "io.streakk": {
            return (image
                ? import("./wallet/io.streakk/image.js").then((img) => img.default)
                : import("./wallet/io.streakk/index.js").then((w) => w.wallet));
        }
        case "com.saitamatoken": {
            return (image
                ? import("./wallet/com.saitamatoken/image.js").then((img) => img.default)
                : import("./wallet/com.saitamatoken/index.js").then((w) => w.wallet));
        }
        case "group.com.flowfoundation.wallet": {
            return (image
                ? import("./wallet/group.com.flowfoundation.wallet/image.js").then((img) => img.default)
                : import("./wallet/group.com.flowfoundation.wallet/index.js").then((w) => w.wallet));
        }
        case "io.hippowallet": {
            return (image
                ? import("./wallet/io.hippowallet/image.js").then((img) => img.default)
                : import("./wallet/io.hippowallet/index.js").then((w) => w.wallet));
        }
        case "io.cosmostation": {
            return (image
                ? import("./wallet/io.cosmostation/image.js").then((img) => img.default)
                : import("./wallet/io.cosmostation/index.js").then((w) => w.wallet));
        }
        case "org.bitizen": {
            return (image
                ? import("./wallet/org.bitizen/image.js").then((img) => img.default)
                : import("./wallet/org.bitizen/index.js").then((w) => w.wallet));
        }
        case "io.blocto": {
            return (image
                ? import("./wallet/io.blocto/image.js").then((img) => img.default)
                : import("./wallet/io.blocto/index.js").then((w) => w.wallet));
        }
        case "com.humbl": {
            return (image
                ? import("./wallet/com.humbl/image.js").then((img) => img.default)
                : import("./wallet/com.humbl/index.js").then((w) => w.wallet));
        }
        case "io.passpay": {
            return (image
                ? import("./wallet/io.passpay/image.js").then((img) => img.default)
                : import("./wallet/io.passpay/index.js").then((w) => w.wallet));
        }
        case "app.ultimate": {
            return (image
                ? import("./wallet/app.ultimate/image.js").then((img) => img.default)
                : import("./wallet/app.ultimate/index.js").then((w) => w.wallet));
        }
        case "me.astrox": {
            return (image
                ? import("./wallet/me.astrox/image.js").then((img) => img.default)
                : import("./wallet/me.astrox/index.js").then((w) => w.wallet));
        }
        case "org.thorwallet": {
            return (image
                ? import("./wallet/org.thorwallet/image.js").then((img) => img.default)
                : import("./wallet/org.thorwallet/index.js").then((w) => w.wallet));
        }
        case "app.fizzwallet": {
            return (image
                ? import("./wallet/app.fizzwallet/image.js").then((img) => img.default)
                : import("./wallet/app.fizzwallet/index.js").then((w) => w.wallet));
        }
        case "app.stickey": {
            return (image
                ? import("./wallet/app.stickey/image.js").then((img) => img.default)
                : import("./wallet/app.stickey/index.js").then((w) => w.wallet));
        }
        case "com.klipwallet": {
            return (image
                ? import("./wallet/com.klipwallet/image.js").then((img) => img.default)
                : import("./wallet/com.klipwallet/index.js").then((w) => w.wallet));
        }
        case "app.coinstats": {
            return (image
                ? import("./wallet/app.coinstats/image.js").then((img) => img.default)
                : import("./wallet/app.coinstats/index.js").then((w) => w.wallet));
        }
        case "land.liker": {
            return (image
                ? import("./wallet/land.liker/image.js").then((img) => img.default)
                : import("./wallet/land.liker/index.js").then((w) => w.wallet));
        }
        case "app.krystal": {
            return (image
                ? import("./wallet/app.krystal/image.js").then((img) => img.default)
                : import("./wallet/app.krystal/index.js").then((w) => w.wallet));
        }
        case "fi.pillar": {
            return (image
                ? import("./wallet/fi.pillar/image.js").then((img) => img.default)
                : import("./wallet/fi.pillar/index.js").then((w) => w.wallet));
        }
        case "io.harti": {
            return (image
                ? import("./wallet/io.harti/image.js").then((img) => img.default)
                : import("./wallet/io.harti/index.js").then((w) => w.wallet));
        }
        case "net.stasis": {
            return (image
                ? import("./wallet/net.stasis/image.js").then((img) => img.default)
                : import("./wallet/net.stasis/index.js").then((w) => w.wallet));
        }
        case "io.novawallet": {
            return (image
                ? import("./wallet/io.novawallet/image.js").then((img) => img.default)
                : import("./wallet/io.novawallet/index.js").then((w) => w.wallet));
        }
        case "io.dttd": {
            return (image
                ? import("./wallet/io.dttd/image.js").then((img) => img.default)
                : import("./wallet/io.dttd/index.js").then((w) => w.wallet));
        }
        case "com.foxwallet": {
            return (image
                ? import("./wallet/com.foxwallet/image.js").then((img) => img.default)
                : import("./wallet/com.foxwallet/index.js").then((w) => w.wallet));
        }
        case "network.haqq": {
            return (image
                ? import("./wallet/network.haqq/image.js").then((img) => img.default)
                : import("./wallet/network.haqq/index.js").then((w) => w.wallet));
        }
        case "com.tomi": {
            return (image
                ? import("./wallet/com.tomi/image.js").then((img) => img.default)
                : import("./wallet/com.tomi/index.js").then((w) => w.wallet));
        }
        case "io.tradestrike": {
            return (image
                ? import("./wallet/io.tradestrike/image.js").then((img) => img.default)
                : import("./wallet/io.tradestrike/index.js").then((w) => w.wallet));
        }
        case "app.subwallet": {
            return (image
                ? import("./wallet/app.subwallet/image.js").then((img) => img.default)
                : import("./wallet/app.subwallet/index.js").then((w) => w.wallet));
        }
        case "tech.okto": {
            return (image
                ? import("./wallet/tech.okto/image.js").then((img) => img.default)
                : import("./wallet/tech.okto/index.js").then((w) => w.wallet));
        }
        case "app.catecoin": {
            return (image
                ? import("./wallet/app.catecoin/image.js").then((img) => img.default)
                : import("./wallet/app.catecoin/index.js").then((w) => w.wallet));
        }
        case "io.ukiss": {
            return (image
                ? import("./wallet/io.ukiss/image.js").then((img) => img.default)
                : import("./wallet/io.ukiss/index.js").then((w) => w.wallet));
        }
        case "com.tellaw": {
            return (image
                ? import("./wallet/com.tellaw/image.js").then((img) => img.default)
                : import("./wallet/com.tellaw/index.js").then((w) => w.wallet));
        }
        case "com.tangem": {
            return (image
                ? import("./wallet/com.tangem/image.js").then((img) => img.default)
                : import("./wallet/com.tangem/index.js").then((w) => w.wallet));
        }
        case "is.callback": {
            return (image
                ? import("./wallet/is.callback/image.js").then((img) => img.default)
                : import("./wallet/is.callback/index.js").then((w) => w.wallet));
        }
        case "io.summonersarena": {
            return (image
                ? import("./wallet/io.summonersarena/image.js").then((img) => img.default)
                : import("./wallet/io.summonersarena/index.js").then((w) => w.wallet));
        }
        case "co.xellar": {
            return (image
                ? import("./wallet/co.xellar/image.js").then((img) => img.default)
                : import("./wallet/co.xellar/index.js").then((w) => w.wallet));
        }
        case "io.talken": {
            return (image
                ? import("./wallet/io.talken/image.js").then((img) => img.default)
                : import("./wallet/io.talken/index.js").then((w) => w.wallet));
        }
        case "xyz.uniultra.wallet": {
            return (image
                ? import("./wallet/xyz.uniultra.wallet/image.js").then((img) => img.default)
                : import("./wallet/xyz.uniultra.wallet/index.js").then((w) => w.wallet));
        }
        case "io.ozonewallet": {
            return (image
                ? import("./wallet/io.ozonewallet/image.js").then((img) => img.default)
                : import("./wallet/io.ozonewallet/index.js").then((w) => w.wallet));
        }
        case "com.tiduswallet": {
            return (image
                ? import("./wallet/com.tiduswallet/image.js").then((img) => img.default)
                : import("./wallet/com.tiduswallet/index.js").then((w) => w.wallet));
        }
        case "world.ixo": {
            return (image
                ? import("./wallet/world.ixo/image.js").then((img) => img.default)
                : import("./wallet/world.ixo/index.js").then((w) => w.wallet));
        }
        case "io.zelcore": {
            return (image
                ? import("./wallet/io.zelcore/image.js").then((img) => img.default)
                : import("./wallet/io.zelcore/index.js").then((w) => w.wallet));
        }
        case "world.dosi.vault": {
            return (image
                ? import("./wallet/world.dosi.vault/image.js").then((img) => img.default)
                : import("./wallet/world.dosi.vault/index.js").then((w) => w.wallet));
        }
        case "com.ullapay": {
            return (image
                ? import("./wallet/com.ullapay/image.js").then((img) => img.default)
                : import("./wallet/com.ullapay/index.js").then((w) => w.wallet));
        }
        case "com.ellipal": {
            return (image
                ? import("./wallet/com.ellipal/image.js").then((img) => img.default)
                : import("./wallet/com.ellipal/index.js").then((w) => w.wallet));
        }
        case "money.unstoppable": {
            return (image
                ? import("./wallet/money.unstoppable/image.js").then((img) => img.default)
                : import("./wallet/money.unstoppable/index.js").then((w) => w.wallet));
        }
        case "dev.auroracloud": {
            return (image
                ? import("./wallet/dev.auroracloud/image.js").then((img) => img.default)
                : import("./wallet/dev.auroracloud/index.js").then((w) => w.wallet));
        }
        case "zone.bitverse": {
            return (image
                ? import("./wallet/zone.bitverse/image.js").then((img) => img.default)
                : import("./wallet/zone.bitverse/index.js").then((w) => w.wallet));
        }
        case "io.konio": {
            return (image
                ? import("./wallet/io.konio/image.js").then((img) => img.default)
                : import("./wallet/io.konio/index.js").then((w) => w.wallet));
        }
        case "net.gateweb3": {
            return (image
                ? import("./wallet/net.gateweb3/image.js").then((img) => img.default)
                : import("./wallet/net.gateweb3/index.js").then((w) => w.wallet));
        }
        case "app.utorg": {
            return (image
                ? import("./wallet/app.utorg/image.js").then((img) => img.default)
                : import("./wallet/app.utorg/index.js").then((w) => w.wallet));
        }
        case "com.coinsdo": {
            return (image
                ? import("./wallet/com.coinsdo/image.js").then((img) => img.default)
                : import("./wallet/com.coinsdo/index.js").then((w) => w.wallet));
        }
        case "app.ammer": {
            return (image
                ? import("./wallet/app.ammer/image.js").then((img) => img.default)
                : import("./wallet/app.ammer/index.js").then((w) => w.wallet));
        }
        case "us.binance": {
            return (image
                ? import("./wallet/us.binance/image.js").then((img) => img.default)
                : import("./wallet/us.binance/index.js").then((w) => w.wallet));
        }
        case "co.muza": {
            return (image
                ? import("./wallet/co.muza/image.js").then((img) => img.default)
                : import("./wallet/co.muza/index.js").then((w) => w.wallet));
        }
        case "com.fxwallet": {
            return (image
                ? import("./wallet/com.fxwallet/image.js").then((img) => img.default)
                : import("./wallet/com.fxwallet/index.js").then((w) => w.wallet));
        }
        case "app.ryipay": {
            return (image
                ? import("./wallet/app.ryipay/image.js").then((img) => img.default)
                : import("./wallet/app.ryipay/index.js").then((w) => w.wallet));
        }
        case "com.roninchain.wallet": {
            return (image
                ? import("./wallet/com.roninchain.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.roninchain.wallet/index.js").then((w) => w.wallet));
        }
        case "org.dota168": {
            return (image
                ? import("./wallet/org.dota168/image.js").then((img) => img.default)
                : import("./wallet/org.dota168/index.js").then((w) => w.wallet));
        }
        case "io.altme": {
            return (image
                ? import("./wallet/io.altme/image.js").then((img) => img.default)
                : import("./wallet/io.altme/index.js").then((w) => w.wallet));
        }
        case "com.bitpie": {
            return (image
                ? import("./wallet/com.bitpie/image.js").then((img) => img.default)
                : import("./wallet/com.bitpie/index.js").then((w) => w.wallet));
        }
        case "io.moonstake": {
            return (image
                ? import("./wallet/io.moonstake/image.js").then((img) => img.default)
                : import("./wallet/io.moonstake/index.js").then((w) => w.wallet));
        }
        case "gg.indi": {
            return (image
                ? import("./wallet/gg.indi/image.js").then((img) => img.default)
                : import("./wallet/gg.indi/index.js").then((w) => w.wallet));
        }
        case "io.yusetoken": {
            return (image
                ? import("./wallet/io.yusetoken/image.js").then((img) => img.default)
                : import("./wallet/io.yusetoken/index.js").then((w) => w.wallet));
        }
        case "com.coininn": {
            return (image
                ? import("./wallet/com.coininn/image.js").then((img) => img.default)
                : import("./wallet/com.coininn/index.js").then((w) => w.wallet));
        }
        case "io.functionx": {
            return (image
                ? import("./wallet/io.functionx/image.js").then((img) => img.default)
                : import("./wallet/io.functionx/index.js").then((w) => w.wallet));
        }
        case "io.pockie": {
            return (image
                ? import("./wallet/io.pockie/image.js").then((img) => img.default)
                : import("./wallet/io.pockie/index.js").then((w) => w.wallet));
        }
        case "com.amazewallet": {
            return (image
                ? import("./wallet/com.amazewallet/image.js").then((img) => img.default)
                : import("./wallet/com.amazewallet/index.js").then((w) => w.wallet));
        }
        case "com.paliwallet": {
            return (image
                ? import("./wallet/com.paliwallet/image.js").then((img) => img.default)
                : import("./wallet/com.paliwallet/index.js").then((w) => w.wallet));
        }
        case "me.easy": {
            return (image
                ? import("./wallet/me.easy/image.js").then((img) => img.default)
                : import("./wallet/me.easy/index.js").then((w) => w.wallet));
        }
        case "live.superex": {
            return (image
                ? import("./wallet/live.superex/image.js").then((img) => img.default)
                : import("./wallet/live.superex/index.js").then((w) => w.wallet));
        }
        case "com.secuxtech": {
            return (image
                ? import("./wallet/com.secuxtech/image.js").then((img) => img.default)
                : import("./wallet/com.secuxtech/index.js").then((w) => w.wallet));
        }
        case "io.didwallet": {
            return (image
                ? import("./wallet/io.didwallet/image.js").then((img) => img.default)
                : import("./wallet/io.didwallet/index.js").then((w) => w.wallet));
        }
        case "social.halo": {
            return (image
                ? import("./wallet/social.halo/image.js").then((img) => img.default)
                : import("./wallet/social.halo/index.js").then((w) => w.wallet));
        }
        case "com.sinohope": {
            return (image
                ? import("./wallet/com.sinohope/image.js").then((img) => img.default)
                : import("./wallet/com.sinohope/index.js").then((w) => w.wallet));
        }
        case "com.ballet": {
            return (image
                ? import("./wallet/com.ballet/image.js").then((img) => img.default)
                : import("./wallet/com.ballet/index.js").then((w) => w.wallet));
        }
        case "com.opz": {
            return (image
                ? import("./wallet/com.opz/image.js").then((img) => img.default)
                : import("./wallet/com.opz/index.js").then((w) => w.wallet));
        }
        case "io.fizen": {
            return (image
                ? import("./wallet/io.fizen/image.js").then((img) => img.default)
                : import("./wallet/io.fizen/index.js").then((w) => w.wallet));
        }
        case "com.kresus": {
            return (image
                ? import("./wallet/com.kresus/image.js").then((img) => img.default)
                : import("./wallet/com.kresus/index.js").then((w) => w.wallet));
        }
        case "com.midoin": {
            return (image
                ? import("./wallet/com.midoin/image.js").then((img) => img.default)
                : import("./wallet/com.midoin/index.js").then((w) => w.wallet));
        }
        case "app.onto": {
            return (image
                ? import("./wallet/app.onto/image.js").then((img) => img.default)
                : import("./wallet/app.onto/index.js").then((w) => w.wallet));
        }
        case "com.oasys-wallet": {
            return (image
                ? import("./wallet/com.oasys-wallet/image.js").then((img) => img.default)
                : import("./wallet/com.oasys-wallet/index.js").then((w) => w.wallet));
        }
        case "org.gooddollar": {
            return (image
                ? import("./wallet/org.gooddollar/image.js").then((img) => img.default)
                : import("./wallet/org.gooddollar/index.js").then((w) => w.wallet));
        }
        case "id.competence": {
            return (image
                ? import("./wallet/id.competence/image.js").then((img) => img.default)
                : import("./wallet/id.competence/index.js").then((w) => w.wallet));
        }
        case "ai.spotonchain.platform": {
            return (image
                ? import("./wallet/ai.spotonchain.platform/image.js").then((img) => img.default)
                : import("./wallet/ai.spotonchain.platform/index.js").then((w) => w.wallet));
        }
        case "network.dgg": {
            return (image
                ? import("./wallet/network.dgg/image.js").then((img) => img.default)
                : import("./wallet/network.dgg/index.js").then((w) => w.wallet));
        }
        case "llc.besc": {
            return (image
                ? import("./wallet/llc.besc/image.js").then((img) => img.default)
                : import("./wallet/llc.besc/index.js").then((w) => w.wallet));
        }
        case "app.gamic": {
            return (image
                ? import("./wallet/app.gamic/image.js").then((img) => img.default)
                : import("./wallet/app.gamic/index.js").then((w) => w.wallet));
        }
        case "baby.smart": {
            return (image
                ? import("./wallet/baby.smart/image.js").then((img) => img.default)
                : import("./wallet/baby.smart/index.js").then((w) => w.wallet));
        }
        case "network.gridlock": {
            return (image
                ? import("./wallet/network.gridlock/image.js").then((img) => img.default)
                : import("./wallet/network.gridlock/index.js").then((w) => w.wallet));
        }
        case "app.zeal": {
            return (image
                ? import("./wallet/app.zeal/image.js").then((img) => img.default)
                : import("./wallet/app.zeal/index.js").then((w) => w.wallet));
        }
        case "com.ivirse": {
            return (image
                ? import("./wallet/com.ivirse/image.js").then((img) => img.default)
                : import("./wallet/com.ivirse/index.js").then((w) => w.wallet));
        }
        case "ch.dssecurity": {
            return (image
                ? import("./wallet/ch.dssecurity/image.js").then((img) => img.default)
                : import("./wallet/ch.dssecurity/index.js").then((w) => w.wallet));
        }
        case "com.concordium": {
            return (image
                ? import("./wallet/com.concordium/image.js").then((img) => img.default)
                : import("./wallet/com.concordium/index.js").then((w) => w.wallet));
        }
        case "io.zkape": {
            return (image
                ? import("./wallet/io.zkape/image.js").then((img) => img.default)
                : import("./wallet/io.zkape/index.js").then((w) => w.wallet));
        }
        case "com.thirdweb": {
            return (image
                ? import("./wallet/com.thirdweb/image.js").then((img) => img.default)
                : import("./wallet/com.thirdweb/index.js").then((w) => w.wallet));
        }
        case "io.pitaka": {
            return (image
                ? import("./wallet/io.pitaka/image.js").then((img) => img.default)
                : import("./wallet/io.pitaka/index.js").then((w) => w.wallet));
        }
        case "com.trusteeglobal": {
            return (image
                ? import("./wallet/com.trusteeglobal/image.js").then((img) => img.default)
                : import("./wallet/com.trusteeglobal/index.js").then((w) => w.wallet));
        }
        case "org.mugambo": {
            return (image
                ? import("./wallet/org.mugambo/image.js").then((img) => img.default)
                : import("./wallet/org.mugambo/index.js").then((w) => w.wallet));
        }
        case "cc.dropp": {
            return (image
                ? import("./wallet/cc.dropp/image.js").then((img) => img.default)
                : import("./wallet/cc.dropp/index.js").then((w) => w.wallet));
        }
        case "xyz.roam.wallet": {
            return (image
                ? import("./wallet/xyz.roam.wallet/image.js").then((img) => img.default)
                : import("./wallet/xyz.roam.wallet/index.js").then((w) => w.wallet));
        }
        case "world.qoin": {
            return (image
                ? import("./wallet/world.qoin/image.js").then((img) => img.default)
                : import("./wallet/world.qoin/index.js").then((w) => w.wallet));
        }
        case "com.meld.app": {
            return (image
                ? import("./wallet/com.meld.app/image.js").then((img) => img.default)
                : import("./wallet/com.meld.app/index.js").then((w) => w.wallet));
        }
        case "com.bestwallet": {
            return (image
                ? import("./wallet/com.bestwallet/image.js").then((img) => img.default)
                : import("./wallet/com.bestwallet/index.js").then((w) => w.wallet));
        }
        case "io.hyperpay": {
            return (image
                ? import("./wallet/io.hyperpay/image.js").then((img) => img.default)
                : import("./wallet/io.hyperpay/index.js").then((w) => w.wallet));
        }
        case "io.xucre": {
            return (image
                ? import("./wallet/io.xucre/image.js").then((img) => img.default)
                : import("./wallet/io.xucre/index.js").then((w) => w.wallet));
        }
        case "app.herewallet": {
            return (image
                ? import("./wallet/app.herewallet/image.js").then((img) => img.default)
                : import("./wallet/app.herewallet/index.js").then((w) => w.wallet));
        }
        case "com.cakewallet": {
            return (image
                ? import("./wallet/com.cakewallet/image.js").then((img) => img.default)
                : import("./wallet/com.cakewallet/index.js").then((w) => w.wallet));
        }
        case "io.unagi.unawallet": {
            return (image
                ? import("./wallet/io.unagi.unawallet/image.js").then((img) => img.default)
                : import("./wallet/io.unagi.unawallet/index.js").then((w) => w.wallet));
        }
        case "io.ethos": {
            return (image
                ? import("./wallet/io.ethos/image.js").then((img) => img.default)
                : import("./wallet/io.ethos/index.js").then((w) => w.wallet));
        }
        case "app.pluswallet": {
            return (image
                ? import("./wallet/app.pluswallet/image.js").then((img) => img.default)
                : import("./wallet/app.pluswallet/index.js").then((w) => w.wallet));
        }
        case "com.authentrend": {
            return (image
                ? import("./wallet/com.authentrend/image.js").then((img) => img.default)
                : import("./wallet/com.authentrend/index.js").then((w) => w.wallet));
        }
        case "finance.plena": {
            return (image
                ? import("./wallet/finance.plena/image.js").then((img) => img.default)
                : import("./wallet/finance.plena/index.js").then((w) => w.wallet));
        }
        case "com.wemix": {
            return (image
                ? import("./wallet/com.wemix/image.js").then((img) => img.default)
                : import("./wallet/com.wemix/index.js").then((w) => w.wallet));
        }
        case "com.gemwallet": {
            return (image
                ? import("./wallet/com.gemwallet/image.js").then((img) => img.default)
                : import("./wallet/com.gemwallet/index.js").then((w) => w.wallet));
        }
        case "com.caesiumlab": {
            return (image
                ? import("./wallet/com.caesiumlab/image.js").then((img) => img.default)
                : import("./wallet/com.caesiumlab/index.js").then((w) => w.wallet));
        }
        case "pro.fintoken": {
            return (image
                ? import("./wallet/pro.fintoken/image.js").then((img) => img.default)
                : import("./wallet/pro.fintoken/index.js").then((w) => w.wallet));
        }
        case "com.peakdefi": {
            return (image
                ? import("./wallet/com.peakdefi/image.js").then((img) => img.default)
                : import("./wallet/com.peakdefi/index.js").then((w) => w.wallet));
        }
        case "com.nodle": {
            return (image
                ? import("./wallet/com.nodle/image.js").then((img) => img.default)
                : import("./wallet/com.nodle/index.js").then((w) => w.wallet));
        }
        case "com.cryptokara": {
            return (image
                ? import("./wallet/com.cryptokara/image.js").then((img) => img.default)
                : import("./wallet/com.cryptokara/index.js").then((w) => w.wallet));
        }
        case "com.poolsmobility.wallet": {
            return (image
                ? import("./wallet/com.poolsmobility.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.poolsmobility.wallet/index.js").then((w) => w.wallet));
        }
        case "com.veworld": {
            return (image
                ? import("./wallet/com.veworld/image.js").then((img) => img.default)
                : import("./wallet/com.veworld/index.js").then((w) => w.wallet));
        }
        case "com.azcoiner": {
            return (image
                ? import("./wallet/com.azcoiner/image.js").then((img) => img.default)
                : import("./wallet/com.azcoiner/index.js").then((w) => w.wallet));
        }
        case "technology.jambo": {
            return (image
                ? import("./wallet/technology.jambo/image.js").then((img) => img.default)
                : import("./wallet/technology.jambo/index.js").then((w) => w.wallet));
        }
        case "vc.uincubator.api": {
            return (image
                ? import("./wallet/vc.uincubator.api/image.js").then((img) => img.default)
                : import("./wallet/vc.uincubator.api/index.js").then((w) => w.wallet));
        }
        case "app.m1nty": {
            return (image
                ? import("./wallet/app.m1nty/image.js").then((img) => img.default)
                : import("./wallet/app.m1nty/index.js").then((w) => w.wallet));
        }
        case "io.noone": {
            return (image
                ? import("./wallet/io.noone/image.js").then((img) => img.default)
                : import("./wallet/io.noone/index.js").then((w) => w.wallet));
        }
        case "com.bitso": {
            return (image
                ? import("./wallet/com.bitso/image.js").then((img) => img.default)
                : import("./wallet/com.bitso/index.js").then((w) => w.wallet));
        }
        case "online.puzzle": {
            return (image
                ? import("./wallet/online.puzzle/image.js").then((img) => img.default)
                : import("./wallet/online.puzzle/index.js").then((w) => w.wallet));
        }
        case "network.blackfort": {
            return (image
                ? import("./wallet/network.blackfort/image.js").then((img) => img.default)
                : import("./wallet/network.blackfort/index.js").then((w) => w.wallet));
        }
        case "io.armana.portal": {
            return (image
                ? import("./wallet/io.armana.portal/image.js").then((img) => img.default)
                : import("./wallet/io.armana.portal/index.js").then((w) => w.wallet));
        }
        case "io.bharatbox": {
            return (image
                ? import("./wallet/io.bharatbox/image.js").then((img) => img.default)
                : import("./wallet/io.bharatbox/index.js").then((w) => w.wallet));
        }
        case "com.greengloryglobal": {
            return (image
                ? import("./wallet/com.greengloryglobal/image.js").then((img) => img.default)
                : import("./wallet/com.greengloryglobal/index.js").then((w) => w.wallet));
        }
        case "com.x9wallet": {
            return (image
                ? import("./wallet/com.x9wallet/image.js").then((img) => img.default)
                : import("./wallet/com.x9wallet/index.js").then((w) => w.wallet));
        }
        case "io.miraiapp": {
            return (image
                ? import("./wallet/io.miraiapp/image.js").then((img) => img.default)
                : import("./wallet/io.miraiapp/index.js").then((w) => w.wallet));
        }
        case "io.kigo": {
            return (image
                ? import("./wallet/io.kigo/image.js").then((img) => img.default)
                : import("./wallet/io.kigo/index.js").then((w) => w.wallet));
        }
        case "com.getcogni": {
            return (image
                ? import("./wallet/com.getcogni/image.js").then((img) => img.default)
                : import("./wallet/com.getcogni/index.js").then((w) => w.wallet));
        }
        case "com.fastex.wallet": {
            return (image
                ? import("./wallet/com.fastex.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.fastex.wallet/index.js").then((w) => w.wallet));
        }
        case "io.wallacy": {
            return (image
                ? import("./wallet/io.wallacy/image.js").then((img) => img.default)
                : import("./wallet/io.wallacy/index.js").then((w) => w.wallet));
        }
        case "org.talkapp": {
            return (image
                ? import("./wallet/org.talkapp/image.js").then((img) => img.default)
                : import("./wallet/org.talkapp/index.js").then((w) => w.wallet));
        }
        case "com.usecapsule": {
            return (image
                ? import("./wallet/com.usecapsule/image.js").then((img) => img.default)
                : import("./wallet/com.usecapsule/index.js").then((w) => w.wallet));
        }
        case "com.unitywallet": {
            return (image
                ? import("./wallet/com.unitywallet/image.js").then((img) => img.default)
                : import("./wallet/com.unitywallet/index.js").then((w) => w.wallet));
        }
        case "app.sinum": {
            return (image
                ? import("./wallet/app.sinum/image.js").then((img) => img.default)
                : import("./wallet/app.sinum/index.js").then((w) => w.wallet));
        }
        case "finance.soulswap.app": {
            return (image
                ? import("./wallet/finance.soulswap.app/image.js").then((img) => img.default)
                : import("./wallet/finance.soulswap.app/index.js").then((w) => w.wallet));
        }
        case "com.shapeshift": {
            return (image
                ? import("./wallet/com.shapeshift/image.js").then((img) => img.default)
                : import("./wallet/com.shapeshift/index.js").then((w) => w.wallet));
        }
        case "finance.panaroma": {
            return (image
                ? import("./wallet/finance.panaroma/image.js").then((img) => img.default)
                : import("./wallet/finance.panaroma/index.js").then((w) => w.wallet));
        }
        case "io.neopin": {
            return (image
                ? import("./wallet/io.neopin/image.js").then((img) => img.default)
                : import("./wallet/io.neopin/index.js").then((w) => w.wallet));
        }
        case "com.alicebob": {
            return (image
                ? import("./wallet/com.alicebob/image.js").then((img) => img.default)
                : import("./wallet/com.alicebob/index.js").then((w) => w.wallet));
        }
        case "co.cyber.wallet": {
            return (image
                ? import("./wallet/co.cyber.wallet/image.js").then((img) => img.default)
                : import("./wallet/co.cyber.wallet/index.js").then((w) => w.wallet));
        }
        case "com.dextrade": {
            return (image
                ? import("./wallet/com.dextrade/image.js").then((img) => img.default)
                : import("./wallet/com.dextrade/index.js").then((w) => w.wallet));
        }
        case "com.hashpack.wallet": {
            return (image
                ? import("./wallet/com.hashpack.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.hashpack.wallet/index.js").then((w) => w.wallet));
        }
        case "org.thepulsewallet": {
            return (image
                ? import("./wallet/org.thepulsewallet/image.js").then((img) => img.default)
                : import("./wallet/org.thepulsewallet/index.js").then((w) => w.wallet));
        }
        case "id.co.pintu": {
            return (image
                ? import("./wallet/id.co.pintu/image.js").then((img) => img.default)
                : import("./wallet/id.co.pintu/index.js").then((w) => w.wallet));
        }
        case "io.bladewallet": {
            return (image
                ? import("./wallet/io.bladewallet/image.js").then((img) => img.default)
                : import("./wallet/io.bladewallet/index.js").then((w) => w.wallet));
        }
        case "com.pandoshi": {
            return (image
                ? import("./wallet/com.pandoshi/image.js").then((img) => img.default)
                : import("./wallet/com.pandoshi/index.js").then((w) => w.wallet));
        }
        case "money.keychain": {
            return (image
                ? import("./wallet/money.keychain/image.js").then((img) => img.default)
                : import("./wallet/money.keychain/index.js").then((w) => w.wallet));
        }
        case "com.mpcvault.broswerplugin": {
            return (image
                ? import("./wallet/com.mpcvault.broswerplugin/image.js").then((img) => img.default)
                : import("./wallet/com.mpcvault.broswerplugin/index.js").then((w) => w.wallet));
        }
        case "io.legacynetwork": {
            return (image
                ? import("./wallet/io.legacynetwork/image.js").then((img) => img.default)
                : import("./wallet/io.legacynetwork/index.js").then((w) => w.wallet));
        }
        case "io.getclave": {
            return (image
                ? import("./wallet/io.getclave/image.js").then((img) => img.default)
                : import("./wallet/io.getclave/index.js").then((w) => w.wallet));
        }
        case "me.iopay": {
            return (image
                ? import("./wallet/me.iopay/image.js").then((img) => img.default)
                : import("./wallet/me.iopay/index.js").then((w) => w.wallet));
        }
        case "app.kabila": {
            return (image
                ? import("./wallet/app.kabila/image.js").then((img) => img.default)
                : import("./wallet/app.kabila/index.js").then((w) => w.wallet));
        }
        case "one.mixin.messenger": {
            return (image
                ? import("./wallet/one.mixin.messenger/image.js").then((img) => img.default)
                : import("./wallet/one.mixin.messenger/index.js").then((w) => w.wallet));
        }
        case "com.bettatrade": {
            return (image
                ? import("./wallet/com.bettatrade/image.js").then((img) => img.default)
                : import("./wallet/com.bettatrade/index.js").then((w) => w.wallet));
        }
        case "io.scramberry": {
            return (image
                ? import("./wallet/io.scramberry/image.js").then((img) => img.default)
                : import("./wallet/io.scramberry/index.js").then((w) => w.wallet));
        }
        case "io.earthwallet": {
            return (image
                ? import("./wallet/io.earthwallet/image.js").then((img) => img.default)
                : import("./wallet/io.earthwallet/index.js").then((w) => w.wallet));
        }
        case "xyz.nestwallet": {
            return (image
                ? import("./wallet/xyz.nestwallet/image.js").then((img) => img.default)
                : import("./wallet/xyz.nestwallet/index.js").then((w) => w.wallet));
        }
        case "xyz.echooo": {
            return (image
                ? import("./wallet/xyz.echooo/image.js").then((img) => img.default)
                : import("./wallet/xyz.echooo/index.js").then((w) => w.wallet));
        }
        case "net.myrenegade": {
            return (image
                ? import("./wallet/net.myrenegade/image.js").then((img) => img.default)
                : import("./wallet/net.myrenegade/index.js").then((w) => w.wallet));
        }
        case "io.ready": {
            return (image
                ? import("./wallet/io.ready/image.js").then((img) => img.default)
                : import("./wallet/io.ready/index.js").then((w) => w.wallet));
        }
        case "ai.hacken": {
            return (image
                ? import("./wallet/ai.hacken/image.js").then((img) => img.default)
                : import("./wallet/ai.hacken/index.js").then((w) => w.wallet));
        }
        case "io.plutope": {
            return (image
                ? import("./wallet/io.plutope/image.js").then((img) => img.default)
                : import("./wallet/io.plutope/index.js").then((w) => w.wallet));
        }
        case "io.trustasset": {
            return (image
                ? import("./wallet/io.trustasset/image.js").then((img) => img.default)
                : import("./wallet/io.trustasset/index.js").then((w) => w.wallet));
        }
        case "app.dfinnwallet": {
            return (image
                ? import("./wallet/app.dfinnwallet/image.js").then((img) => img.default)
                : import("./wallet/app.dfinnwallet/index.js").then((w) => w.wallet));
        }
        case "com.bmawallet": {
            return (image
                ? import("./wallet/com.bmawallet/image.js").then((img) => img.default)
                : import("./wallet/com.bmawallet/index.js").then((w) => w.wallet));
        }
        case "net.spatium.wallet": {
            return (image
                ? import("./wallet/net.spatium.wallet/image.js").then((img) => img.default)
                : import("./wallet/net.spatium.wallet/index.js").then((w) => w.wallet));
        }
        case "io.transi": {
            return (image
                ? import("./wallet/io.transi/image.js").then((img) => img.default)
                : import("./wallet/io.transi/index.js").then((w) => w.wallet));
        }
        case "com.dolletwallet": {
            return (image
                ? import("./wallet/com.dolletwallet/image.js").then((img) => img.default)
                : import("./wallet/com.dolletwallet/index.js").then((w) => w.wallet));
        }
        case "app.wombat": {
            return (image
                ? import("./wallet/app.wombat/image.js").then((img) => img.default)
                : import("./wallet/app.wombat/index.js").then((w) => w.wallet));
        }
        case "fi.dropmate": {
            return (image
                ? import("./wallet/fi.dropmate/image.js").then((img) => img.default)
                : import("./wallet/fi.dropmate/index.js").then((w) => w.wallet));
        }
        case "pub.dg": {
            return (image
                ? import("./wallet/pub.dg/image.js").then((img) => img.default)
                : import("./wallet/pub.dg/index.js").then((w) => w.wallet));
        }
        case "com.icewal": {
            return (image
                ? import("./wallet/com.icewal/image.js").then((img) => img.default)
                : import("./wallet/com.icewal/index.js").then((w) => w.wallet));
        }
        case "one.metapro.wallet": {
            return (image
                ? import("./wallet/one.metapro.wallet/image.js").then((img) => img.default)
                : import("./wallet/one.metapro.wallet/index.js").then((w) => w.wallet));
        }
        case "xyz.bonuz": {
            return (image
                ? import("./wallet/xyz.bonuz/image.js").then((img) => img.default)
                : import("./wallet/xyz.bonuz/index.js").then((w) => w.wallet));
        }
        case "io.shido": {
            return (image
                ? import("./wallet/io.shido/image.js").then((img) => img.default)
                : import("./wallet/io.shido/index.js").then((w) => w.wallet));
        }
        case "co.lifedefi": {
            return (image
                ? import("./wallet/co.lifedefi/image.js").then((img) => img.default)
                : import("./wallet/co.lifedefi/index.js").then((w) => w.wallet));
        }
        case "fun.tobi": {
            return (image
                ? import("./wallet/fun.tobi/image.js").then((img) => img.default)
                : import("./wallet/fun.tobi/index.js").then((w) => w.wallet));
        }
        case "app.clot": {
            return (image
                ? import("./wallet/app.clot/image.js").then((img) => img.default)
                : import("./wallet/app.clot/index.js").then((w) => w.wallet));
        }
        case "me.komet.app": {
            return (image
                ? import("./wallet/me.komet.app/image.js").then((img) => img.default)
                : import("./wallet/me.komet.app/index.js").then((w) => w.wallet));
        }
        case "io.guardiianwallet": {
            return (image
                ? import("./wallet/io.guardiianwallet/image.js").then((img) => img.default)
                : import("./wallet/io.guardiianwallet/index.js").then((w) => w.wallet));
        }
        case "io.wallypto": {
            return (image
                ? import("./wallet/io.wallypto/image.js").then((img) => img.default)
                : import("./wallet/io.wallypto/index.js").then((w) => w.wallet));
        }
        case "com.safemoon": {
            return (image
                ? import("./wallet/com.safemoon/image.js").then((img) => img.default)
                : import("./wallet/com.safemoon/index.js").then((w) => w.wallet));
        }
        case "com.elrond.maiar.wallet": {
            return (image
                ? import("./wallet/com.elrond.maiar.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.elrond.maiar.wallet/index.js").then((w) => w.wallet));
        }
        case "co.swopme": {
            return (image
                ? import("./wallet/co.swopme/image.js").then((img) => img.default)
                : import("./wallet/co.swopme/index.js").then((w) => w.wallet));
        }
        case "com.bitpay": {
            return (image
                ? import("./wallet/com.bitpay/image.js").then((img) => img.default)
                : import("./wallet/com.bitpay/index.js").then((w) => w.wallet));
        }
        case "app.tofee": {
            return (image
                ? import("./wallet/app.tofee/image.js").then((img) => img.default)
                : import("./wallet/app.tofee/index.js").then((w) => w.wallet));
        }
        case "com.zypto": {
            return (image
                ? import("./wallet/com.zypto/image.js").then((img) => img.default)
                : import("./wallet/com.zypto/index.js").then((w) => w.wallet));
        }
        case "xyz.orion": {
            return (image
                ? import("./wallet/xyz.orion/image.js").then((img) => img.default)
                : import("./wallet/xyz.orion/index.js").then((w) => w.wallet));
        }
        case "io.uptn.dapp-web": {
            return (image
                ? import("./wallet/io.uptn.dapp-web/image.js").then((img) => img.default)
                : import("./wallet/io.uptn.dapp-web/index.js").then((w) => w.wallet));
        }
        case "app.nicegram": {
            return (image
                ? import("./wallet/app.nicegram/image.js").then((img) => img.default)
                : import("./wallet/app.nicegram/index.js").then((w) => w.wallet));
        }
        case "finance.openwallet": {
            return (image
                ? import("./wallet/finance.openwallet/image.js").then((img) => img.default)
                : import("./wallet/finance.openwallet/index.js").then((w) => w.wallet));
        }
        case "com.tastycrypto": {
            return (image
                ? import("./wallet/com.tastycrypto/image.js").then((img) => img.default)
                : import("./wallet/com.tastycrypto/index.js").then((w) => w.wallet));
        }
        case "com.ipmb": {
            return (image
                ? import("./wallet/com.ipmb/image.js").then((img) => img.default)
                : import("./wallet/com.ipmb/index.js").then((w) => w.wallet));
        }
        case "com.daffione": {
            return (image
                ? import("./wallet/com.daffione/image.js").then((img) => img.default)
                : import("./wallet/com.daffione/index.js").then((w) => w.wallet));
        }
        case "io.owallet": {
            return (image
                ? import("./wallet/io.owallet/image.js").then((img) => img.default)
                : import("./wallet/io.owallet/index.js").then((w) => w.wallet));
        }
        case "com.beexo": {
            return (image
                ? import("./wallet/com.beexo/image.js").then((img) => img.default)
                : import("./wallet/com.beexo/index.js").then((w) => w.wallet));
        }
        case "com.webauth": {
            return (image
                ? import("./wallet/com.webauth/image.js").then((img) => img.default)
                : import("./wallet/com.webauth/index.js").then((w) => w.wallet));
        }
        case "id.plumaa": {
            return (image
                ? import("./wallet/id.plumaa/image.js").then((img) => img.default)
                : import("./wallet/id.plumaa/index.js").then((w) => w.wallet));
        }
        case "social.gm2": {
            return (image
                ? import("./wallet/social.gm2/image.js").then((img) => img.default)
                : import("./wallet/social.gm2/index.js").then((w) => w.wallet));
        }
        case "nl.greenhood.wallet": {
            return (image
                ? import("./wallet/nl.greenhood.wallet/image.js").then((img) => img.default)
                : import("./wallet/nl.greenhood.wallet/index.js").then((w) => w.wallet));
        }
        case "com.coinbase.wallet": {
            return (image
                ? import("./wallet/com.coinbase.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.coinbase.wallet/index.js").then((w) => w.wallet));
        }
        case "app.phantom": {
            return (image
                ? import("./wallet/app.phantom/image.js").then((img) => img.default)
                : import("./wallet/app.phantom/index.js").then((w) => w.wallet));
        }
        case "io.rabby": {
            return (image
                ? import("./wallet/io.rabby/image.js").then((img) => img.default)
                : import("./wallet/io.rabby/index.js").then((w) => w.wallet));
        }
        case "com.brave.wallet": {
            return (image
                ? import("./wallet/com.brave.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.brave.wallet/index.js").then((w) => w.wallet));
        }
        case "io.xdefi": {
            return (image
                ? import("./wallet/io.xdefi/image.js").then((img) => img.default)
                : import("./wallet/io.xdefi/index.js").then((w) => w.wallet));
        }
        case "com.moongate.one": {
            return (image
                ? import("./wallet/com.moongate.one/image.js").then((img) => img.default)
                : import("./wallet/com.moongate.one/index.js").then((w) => w.wallet));
        }
        case "com.blanqlabs.wallet": {
            return (image
                ? import("./wallet/com.blanqlabs.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.blanqlabs.wallet/index.js").then((w) => w.wallet));
        }
        case "tech.levain": {
            return (image
                ? import("./wallet/tech.levain/image.js").then((img) => img.default)
                : import("./wallet/tech.levain/index.js").then((w) => w.wallet));
        }
        case "com.enkrypt": {
            return (image
                ? import("./wallet/com.enkrypt/image.js").then((img) => img.default)
                : import("./wallet/com.enkrypt/index.js").then((w) => w.wallet));
        }
        case "com.scramble": {
            return (image
                ? import("./wallet/com.scramble/image.js").then((img) => img.default)
                : import("./wallet/com.scramble/index.js").then((w) => w.wallet));
        }
        case "io.finoa": {
            return (image
                ? import("./wallet/io.finoa/image.js").then((img) => img.default)
                : import("./wallet/io.finoa/index.js").then((w) => w.wallet));
        }
        case "inc.tomo": {
            return (image
                ? import("./wallet/inc.tomo/image.js").then((img) => img.default)
                : import("./wallet/inc.tomo/index.js").then((w) => w.wallet));
        }
        case "com.walletconnect.com": {
            return (image
                ? import("./wallet/com.walletconnect.com/image.js").then((img) => img.default)
                : import("./wallet/com.walletconnect.com/index.js").then((w) => w.wallet));
        }
        case "io.leapwallet.CompassWallet": {
            return (image
                ? import("./wallet/io.leapwallet.CompassWallet/image.js").then((img) => img.default)
                : import("./wallet/io.leapwallet.CompassWallet/index.js").then((w) => w.wallet));
        }
        case "app.nightly": {
            return (image
                ? import("./wallet/app.nightly/image.js").then((img) => img.default)
                : import("./wallet/app.nightly/index.js").then((w) => w.wallet));
        }
        case "com.blazpay.wallet": {
            return (image
                ? import("./wallet/com.blazpay.wallet/image.js").then((img) => img.default)
                : import("./wallet/com.blazpay.wallet/index.js").then((w) => w.wallet));
        }
        case "com.lootrush": {
            return (image
                ? import("./wallet/com.lootrush/image.js").then((img) => img.default)
                : import("./wallet/com.lootrush/index.js").then((w) => w.wallet));
        }
        case "app.core.extension": {
            return (image
                ? import("./wallet/app.core.extension/image.js").then((img) => img.default)
                : import("./wallet/app.core.extension/index.js").then((w) => w.wallet));
        }
        case "xyz.dawnwallet": {
            return (image
                ? import("./wallet/xyz.dawnwallet/image.js").then((img) => img.default)
                : import("./wallet/xyz.dawnwallet/index.js").then((w) => w.wallet));
        }
        case "xyz.abs": {
            return (image
                ? import("./wallet/xyz.abs/image.js").then((img) => img.default)
                : import("./wallet/xyz.abs/index.js").then((w) => w.wallet));
        }
        default: {
            throw new Error(`Wallet with id ${id} not found`);
        }
    }
}
//# sourceMappingURL=getWalletInfo.js.map